//Dependencies
import React from 'react';
import ProgressiveImage from 'react-progressive-graceful-image';
import { useDispatch } from 'react-redux';

/* BOTONES DE PORTAFOLIO */
const Thumbnail01 = (props) =>
{
  const { counter, name, images, highlight, width } = props;

  const dispatch = useDispatch();

  const onTagClick = (value) =>
  {
    dispatch({type: 'SET_PORTFOLIO_COUNTER', counter : value});
  }

  return(
    <div
      className = {highlight ? 'cursor-pointer' : 'border border-solid border-black cursor-pointer'}      
      onClick   = {() => onTagClick(counter)}

      style     = {{width : width, height : width, border: highlight ? '4px solid #00ff40' : null}}
    >
      <ProgressiveImage 
        src = {images.image} 
        placeholder = {images.placeholder}
      >
        {(src) => {
          return (
            <img 
                className = "progressive-image" 
                src = {src} 
                style = 
                {{ 
                  height: '80%', 
                  width: '100%', 
                }} 
                alt = {images.alt}
              />
          );
        }}
      </ProgressiveImage>
      
      <div
        className = "flex border-t border-solid border-black justify-center bg-sky-500 items-center"
        style = 
        {{ 
          height: '20%', 
          width: '100%', 
        }}   
      >
        <h2
          className = "m-0 p-0 flex justify-center text-xs md:text-xs lg:text-base  font-bold uppercase items-center	text-white"
        >          
          {name.toUpperCase()}
        </h2>    
      </div>
    </div>
  );
}

export default Thumbnail01;